<!-- 修改电表倍率弹窗 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">费率计费</template>
		<div v-if="infos">
			<div class="chargeName">
				<label><span class="required">*</span>计费名称</label>
				<input class="textInput" type="text" v-model.trim="infos.name" maxlength="20" placeholder="请输入名称" />
			</div>
			<!--tabs标签-->
			<el-tabs type="border-card"  >
				<el-tab-pane  v-for = "(item,index)  in infos.detail" :key="index">
					<span slot="label"><i class="el-icon-date"></i> {{item.tname}}</span>
					<input class="textInput" type="number" v-model="nowChargeMode[index].rateMoney"/>
				</el-tab-pane>
			</el-tabs>
		</div>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	export default {
		components: {
			dialogBody
		},
		props: {

		},
		data() {
			return {
				infos: {
				},
				nowActId: '',
				callback: undefined,
				nowChargeMode: []
			}
		},
		computed: {

			canSave() {
				if(this.infos.name == ''){
					this.$dialogMethod.showMessage('请输入计费名称')
					return false
				}
				var num = 0;
				var that = this;
				this.nowChargeMode.forEach(function (item) {

					if (isNaN(parseFloat(item.rateMoney))){
						that.$dialogMethod.showMessage("请输入格式正确的价格");
						++num;
						return false;
					}

					if (parseFloat(item.rateMoney) <= 0){
						that.$dialogMethod.showMessage("计费价格不能设置为0");
						++num;
						return false;
					}

				});

				if (num>0){
					return false;
				}

				return true
			}

		},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				if(!this.canSave){
					return
				}
				if(this.callback != undefined){

					var result = {
						pkid:this.infos.pkid,
						id:this.infos.id,
						name:this.infos.name,
						billingMode: 'PeakAndValleyBilling',//尖峰平谷
						deductionStandard:  this.nowChargeMode
					}
					this.callback(result)
				}
				this.close()
			},
			cancel() {
				this.close()
			},
			close() {
				this.$refs.body.hide()
			},
			open(title, type, nowInfos, callback) {
				this.title = title
				this.callback = callback
				if(!isempty(nowInfos)){
					this.infos = nowInfos;
					this.nowChargeMode = nowInfos.detail;

				}else {
					this.infos.name = "";
					this.infos.pkid = "";
					this.infos.id = "";
					this.infos.unitId = "";
					this.infos.detail = [
						{
							"type": 1,
							"rateMoney": 0,
							"billingModeId": "",
							"id": "",
							"tname": "尖"
						},
						{
							"type": 2,
							"rateMoney": 0,
							"billingModeId": "",
							"id": "",
							"tname": "峰"
						},
						{
							"type": 3,
							"rateMoney": 0,
							"billingModeId": "",
							"id": "",
							"tname": "平"
						},
						{
							"type": 4,
							"rateMoney": 0,
							"billingModeId": "",
							"id": "",
							"tname": "谷"
						}

					]

					this.nowChargeMode = this.infos.detail;

				}
				this.$refs.body.open()
			}

		}
	}
</script>
<style scoped>
	.chargeName{
		display: flex;
		align-items: center;
		line-height: 36px;
		padding: 10px 0;
		border-bottom: solid 6px #F2F2F2;
	}

	.chargeName>label{
		margin-right: 10px;
		flex-grow: 0;
	}

	.chargeName>p{
		line-height: 34px;
		height: 34px;
		padding: 0 10px;
		flex-grow: 1;
		border: solid 1px #E4E4E4;
		border-radius: 5px;
		overflow: hidden;
		white-space: nowrap;
		text-overflow:ellipsis;
	}


	.tabHead{
		border-bottom: solid 1px #E4E4E4;
	}

	.tabHead>span{
		display: inline-block;
		width: 50px;
		text-align: center;
		margin-right: 30px;
		line-height: 30px;
		position: relative;
		top: 1px;
		cursor: pointer;
	}

	.tabAct{
		color: #409EFF;
		border-bottom: solid 1px #409EFF;
	}

	.rateMoneyTime{
		padding: 10px 0;
		display: flex;
		flex-wrap: wrap;
		align-content: flex-start;
		max-height: 220px;
	}

	.rateMoneyTime>li{
		margin: 0 5px 10px 5px;
		background-color: #ECF5FF;
		border: solid 1px #409EFF;
		color: #409EFF;
		border-radius: 5px;
		padding: 8px 10px;
	}
</style>